module.exports = __webpack_public_path__ + "img/account-application-bg.d63e30ee.svg";